import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { keys } from 'sdk';

import { useSDK } from '../../../../app';
import { styled } from '../../../../styled';
import { AttachmentsPreviewList } from './attachmentsPreviewList';
import { AttachmentError } from './attachmentsPreviewList/attachmentError';
import { ChatFieldContainer } from './chatFiledContainer/chatFieldContainer';
import { commonStyles, Interface, useLogic } from './common';
import { EmojiPicker } from './emojiPicker';
import { MessageFieldButtonsChat } from './messageFieldButtons/chat';
import { ReplyPreview } from './reply';
import { Suggestions } from './suggestions';
import { TextArea } from './textarea/textarea';

const Component = observer(
	({
		value,
		disabled,
		className,
		onSuggestionSelect,
		withAttachments = true,
		onChange: onChangeProp,
		onSendClick: onSendClickProp,
	}: Interface): ReactElement => {
		const { suggestionsStore, welcomeDataStore, conversationsStore } = useSDK();
		const {
			attachmentsInputRef,
			onKeyPress,
			onSendClick,
			onAttachmentLoad,
			onChange,
			setShowEmoji,
			showEmoji,
			textarea,
			scrollbar,
			onEmojiPick,
		} = useLogic(onSendClickProp, withAttachments, onChangeProp, value);
		const [buttonsInRow, setButtonsInRow] = useState(true);
		return (
			<>
				{(suggestionsStore.suggestions[value] &&
					keys(suggestionsStore.suggestions[value]).length &&
					!conversationsStore.isCurrentDialogDistributed &&
					onSuggestionSelect && (
						<Suggestions
							onSuggestionSelect={onSuggestionSelect}
							suggestions={suggestionsStore.suggestions[value]}
						/>
					)) ||
					null}
				<ChatFieldContainer>
					<EmojiPicker position="absolute" onEmojiPick={onEmojiPick} isShow={showEmoji} />
					<AttachmentError />
					<ReplyPreview />
					<AttachmentsPreviewList attachmentLoadHandler={onAttachmentLoad || undefined} />
					<div className={className}>
						<MessageFieldButtonsChat
							inRow={buttonsInRow}
							textareaRef={textarea}
							setShowEmoji={setShowEmoji}
							emojiPanelActive={showEmoji}
							withAttachments={withAttachments}
							onSendClick={disabled ? (): void => void 0 : onSendClick}
							onAttachmentClick={(): void => attachmentsInputRef.current?.click()}
						>
							<TextArea
								onKeyPress={disabled ? (): void => void 0 : onKeyPress}
								onChange={onChange}
								scrollbar={scrollbar}
								value={value}
								textareaRef={textarea}
								placeholder={welcomeDataStore.data?.showcase.messagePlaceholder}
								setInRow={setButtonsInRow}
								inRow={buttonsInRow}
							/>
						</MessageFieldButtonsChat>
						{withAttachments && (
							<input
								className="hidden_input"
								accept={welcomeDataStore.data?.allowedExtensions.map((ext) => '.' + ext).join(',')}
								onChange={onAttachmentLoad?.onAttachmentLoad || undefined}
								ref={attachmentsInputRef}
								type="file"
							/>
						)}
					</div>
				</ChatFieldContainer>
			</>
		);
	}
);

const MessageFieldChat = styled(Component)(
	commonStyles,
	css`
		align-items: flex-end;
		display: flex;
		padding: 8px;
		div&:focus-within {
			border-bottom: 0;
			border-left: 0;
			border-radius: 0;
			border-right: 0;
		}

		div&.focus-within {
			border-bottom: 0;
			border-left: 0;
			border-radius: 0;
			border-right: 0;
		}

		div& {
			border-bottom: 0;
			border-left: 0;
			border-radius: 0;
			border-right: 0;
			margin: 0;
		}
	`
);

export { MessageFieldChat };
